import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  60% {
    transform: scale(1.3);
  }
  95% {
    transform: scale(1);
  }
`;

const Pulse = styled.div`
  animation: ${pulse} 1.5s infinite ease-in-out;
`;

export default Pulse;
